import React from 'react';
import Box from '@mui/material/Box';
import ActionableBanner from 'components/pages/ActionableBanner';
import withSignUpDialog from 'components/hoc/withSignUpDialog';
import usePermissions from 'hooks/usePermissions';
import { auth, useAuthState } from 'api/services/firebase';
import GuestHome from 'components/pages/Home/GuestHome';
import UserHome from 'components/pages/Home/UserHome';
import Container from '@mui/material/Container';
import './home.css';

const styles = {
  container: {
    margin: '0 40px',
    height: '100%',
    overflow: 'hidden',
    minWidth: '910px',
    minHeight: '500px',
  },
};

const Home = React.memo(({ openSignUpDialog }) => {
  const { hasPermission } = usePermissions();
  const [user] = useAuthState(auth);
  const isGuest = !user;

  return (
    <Box
      id="home2"
      sx={{
        width: '100%', height: '100%', overflow: 'auto', scrollBehavior: 'smooth',
      }}
    >
      {isGuest ? (
        <Box id="home1" sx={{ ...styles.container }}>
          {hasPermission('promo.banner') && <ActionableBanner />}
          <GuestHome openSignUpDialog={openSignUpDialog} />
        </Box>
      ) : (
        <Box>
          {hasPermission('promo.banner') && <Container><ActionableBanner /></Container>}
          <UserHome />
        </Box>
      )}
    </Box>
  );
});
export default withSignUpDialog(Home);
